import { ToolsConfiguration } from '@3ddv/ngx-sites-builder-lib';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Sidebar } from '../sb-editor-sidebar/models/sidebar.model';
import { SidebarService } from '../sb-editor-sidebar/services/sidebar.service';
import { SblibService } from '../services/sblib.service';
import { ToolsService } from './services/tools.service';

@Component({
  selector: 'app-sb-editor-tools',
  templateUrl: './sb-editor-tools.component.html',
  styleUrls: ['./sb-editor-tools.component.scss'],
})
export class SbEditorToolsComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public sidebar: Sidebar;
  public toolsName: { [key: string]: string };
  public toolsConfig: ToolsConfiguration;
  public msInProgress: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private sidebarService: SidebarService,
    private sblibService: SblibService,
    private toolsService: ToolsService
  ) {
    this.subscriptions = [];
    this.toolsName = {
      availability: 'Disponibilidad',
      colors: 'Plantillas web',
      comparator: 'Comparador',
      plugins: 'Panos / 360 Views',
      minimap: 'Minimapa',
      multivenue: 'Configuraciones',
      neighbours: 'Neighbours',
      popups: 'Popups',
      searcher: 'Buscador',
      header: 'Cabecera',
      translation: 'Traducciones',
      filters: 'Filtros',
      extern: 'Ficheros ext.',
      map: 'Mapa',
      vipinfo: 'Custom buttons',
      disclaimer: 'Disclaimer',
      language: 'Language',
    };
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  ngOnInit(): void {
    let f = this.activatedRoute.snapshot.data.dataFlow;
    // parse db to readable data for the lib
    this.toolsConfig = {};
    f.workflow.tools.forEach(i => {
      this.toolsConfig[i.name.toLowerCase()] = i.values;
    });

    let defaultTools = this.toolsService.editDefaultTools(this.toolsConfig, f.workflow.id);
    // Edit tools config on workflow by default
    this.toolsConfig = this.toolsService.editDefaultTools(this.toolsConfig, f.workflow.id);

    if (this.activatedRoute.snapshot.data.site && this.activatedRoute.snapshot.data.site.master) {
      this.toolsConfig = Object.assign({}, defaultTools);
      this.mergeTools(this.toolsConfig, this.activatedRoute.snapshot.data.site.master.toolsConfig);
      //this.toolsConfig = Object.assign({}, defaultTools, this.activatedRoute.snapshot.data.site.master.toolsConfig);
    }

    //console.log('ToolsConfig: ', this.toolsConfig);
    this.toolsService.setAsyncTools$(this.toolsConfig);

    const sidebar$ = this.sidebarService.getAsyncSidebar$().subscribe(res => {
      this.sidebar = res;
    });
    this.subscriptions.push(sidebar$);
  }

  public mergeTools(defaultTools, masterTools) {
    for (const key in masterTools) {
      if (masterTools.hasOwnProperty(key)) {
        if (masterTools[key] instanceof Blob || masterTools[key] instanceof File) {
          defaultTools[key] = masterTools[key];
        } else if (
          typeof masterTools[key] === 'object' &&
          masterTools[key] !== null &&
          !Array.isArray(masterTools[key])
        ) {
          if (!defaultTools[key]) {
            defaultTools[key] = {};
          }
          this.mergeTools(defaultTools[key], masterTools[key]);
        } else {
          defaultTools[key] = masterTools[key];
        }
      }
    }
  }

  public onToolSelected(toolname): void {
    if (this.sidebar.active === toolname) {
      this.sidebar.active = null;
      this.sidebar.text = '';
      this.sidebar.grid.extended = false;
      this.sidebar.grid.hidden = true;
    } else {
      this.sidebar.active = toolname;
      this.sidebar.text = this.toolsName[toolname];
      this.sidebar.grid.hidden = false;
    }
    this.sidebarService.setSidebar(this.sidebar);
    this.sblibService.sblib.runonclick();
  }
}
